export { default } from './truncated-text-with-tooltip';
